import { React, useEffect, useState } from 'react';
import { alpha, styled, useTheme } from '@mui/material/styles';
import { Typography, Avatar, Card, CardContent, Divider, IconButton, CardMedia, CardHeader, Skeleton } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { red } from '@mui/material/colors';
import { useSelector } from "react-redux";
import { Link as RouterLink, useParams, useNavigate, Link } from 'react-router-dom';
import AppsService from '../../../services/apps_service'
import LoadingScreen from 'react-loading-screen';

const useStyles = styled((theme) => ({
    root: {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(2),
        color: "#ccc",
        backgroundColor: theme.palette.background.default,
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        marginLeft: theme.spacing(2),
    },
    title: {
        fontWeight: 500,
        color: theme.palette.text.primary,
    },
    id: {
        color: theme.palette.text.secondary,
    },
}));

export default function AppTopBar() {

    const params = useParams();
    const theme = useTheme();
    const styles = useStyles(theme);

    const navigate = useNavigate();
    const [shortObj, setApp] = useState(null);

    const [loading, setIsLoading] = useState(true);
    const { type, app } = useSelector((state) => state.app_info);

    function loadAppShortInfo() {
        AppsService.getAppInfo(app.app, 'short')
            .then((response) => setApp(response.data))
            .then((data) => setIsLoading(false))
    }

    useEffect(() => {

        if (type === 'APP') {
            setIsLoading(true);
            loadAppShortInfo();
        }
    }, [type, app]);


    function handleClick() {
        navigate('/apps/' + app.app);
    }

    if (type === 'APP') {
        if (loading) {
            return <></>
            // (
            //     <LoadingScreen
            //         loading={true}
            //         bgColor="rgba(255,255,255,0.8)"
            //         spinnerColor="#9ee5f8"
            //         textColor="#676767"
            //         logoSrc=""
            //         text=""
            //     >
            //         {" "}
            //     </LoadingScreen>
            // )
        }
        else {
            return (
                <Card onClick={handleClick} variant="outlined" sx={{ backgroundColor: "transparent", boxShadow: 0, borderRadius: 0, border: 0, cursor: 'pointer' }}>
                    <CardHeader
                        avatar={
                            <Avatar src={shortObj.app_icon} aria-label="recipe">

                            </Avatar>
                        }

                        title={shortObj.app_name}
                        subheader={shortObj.seller_name}
                    />


                </Card>
            );
        }
    } else {
        return <></>
    }
}